import http from '@/http';

const SafraService = {
  async buscarLkpSafra() {
    const responseSafra = await http.get("/api/astec/getLkpSafra");
    return responseSafra.data.map(item => ({
      name: item.DISPLAY,
      value: item.ID,
      epoca: item.TPEPOCA,
    }));
  }
};
export default SafraService;
